import { DocumentNode } from "graphql";
import { FlexContext } from "./flex-context";
import { FlexSectionController } from "./flex-section-controller";

export interface InitialRequestConfig {
	queries: Array<DocumentNode>;
	variables: { [key: string]: unknown };
}

export const createSectionInitialRequestPart = (controller: FlexSectionController): Array<InitialRequestConfig> => {
	return controller.fieldControllers
		.concat(controller.sectionControllers.flatMap((s) => s.fieldControllers))
		.map((f) => f.getInitialRequestComponents?.())
		.concat(controller.sectionControllers.flatMap((sc) => createSectionInitialRequestPart(sc)))
		.filter(Boolean) as Array<InitialRequestConfig>;
};

export const createInitialRequestConfig = (typeModel: FlexContext): InitialRequestConfig => {
	return typeModel.sectionControllers.flatMap(createSectionInitialRequestPart).reduce(
		(a, c) => ({
			queries: [...a.queries, ...c.queries],
			variables: { ...a.variables, ...c.variables },
		}),
		{ queries: [], variables: {} }
	);
};
